export default __webpack_public_path__ + "static/scroll-bccf4aa70ba1bbb77be8101c035bdcce.gif";